import React from "react";
import { Workflow, BCMSDate, BCMSRecord, useBCMSContext, useParams, useModel } from "@bcm-dev/bcms-vite";
import { Transaction ,LinkedAccount} from "model";
import OneTimePaymentPage from "components/pages/OneTimePaymentPage";
import OneTimeFormView from "components/pages/OneTimePaymentPage/components/OneTimeFormView";
import OneTimeReviewView from "components/pages/OneTimePaymentPage/components/OneTimeReviewView";
import OneTimeScheduledView from "components/pages/OneTimePaymentPage/components/OneTimeScheduledView";


const steps = [<OneTimePaymentPage view={<OneTimeFormView/>}></OneTimePaymentPage>,
<OneTimePaymentPage view={<OneTimeReviewView/>}></OneTimePaymentPage>
,<OneTimePaymentPage view={<OneTimeScheduledView/>}></OneTimePaymentPage>];

/**
 * @function OneTimePaymentWorkFlow
 * @returns {React.Component}
 * @description The main component for the dispute transaction workflow.
 * @exported true
 * @example <DisputeTransactionWorkflow />
 */
export default function OneTimePaymentWorkFlow(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor([ LinkedAccount ], globalController);
    const transactionID = useParams().transactionID ?? "0";
    const value = getDefault(globalController, transactionID);
    return <Workflow value={ value } steps={ steps } />;
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Hook to return the steps of the workflow
 * @exported true
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @returns {OBJECT}
 * @exported true
 * @description Returns the default values for the dispute transaction
 */
export const getDefault = (controller, transactionID) => {


 

    return {
        date: BCMSDate.init().offset(1),
        amountSelect: undefined,
        account: LinkedAccount.initByID("0"),
        card:undefined,
        amount:undefined
      
    }
};